import React from "react";
import Typography from '@mui/material/Typography';

import RegisterInterestLink from './RegisterInterestLink';
import { formatPrice } from "../util/formatPrice";

interface PriceProps {
  price?: string;
  size?: number;
}

const Price = (props: PriceProps) => {
  if (!props.price) return (
    <Typography
      variant="subtitle2"
      sx={{ background: "#f2c53d", borderRadius: "8px", padding: "4px" }}
    >
      Price isn't available yet. Kindly register your interest <RegisterInterestLink />
    </Typography>
  )

  if (props.price === "error") return (
    <Typography
      variant="subtitle2"
      sx={{ background: "orange", borderRadius: "8px", padding: "4px" }}
    >
      We are experiencing some issues.
      Kindly seek a quotation from us.
    </Typography>
  )

  return (
    <React.Fragment>
      <Typography
        fontWeight="600"
        fontSize={props.size || 15}
      >
        S${formatPrice(props.price)}
      </Typography>
    </React.Fragment>
  )
}

export default Price;